var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#2196F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20C6 12.268 12.268 6 20 6C27.732 6 34 12.268 34 20C34 27.732 27.732 34 20 34C12.268 34 6 27.732 6 20ZM21.6 13.6C21.6 14.4837 20.8837 15.2 20 15.2C19.1163 15.2 18.4 14.4837 18.4 13.6C18.4 12.7163 19.1163 12 20 12C20.8837 12 21.6 12.7163 21.6 13.6ZM20 18C20.6627 18 21.2 18.5373 21.2 19.2V27.2C21.2 27.8627 20.6627 28.4 20 28.4C19.3373 28.4 18.8 27.8627 18.8 27.2V19.2C18.8 18.5373 19.3373 18 20 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastInformation);
export default __webpack_public_path__ + "static/media/toast_information.091d53274245a8f699f630428e776b06.svg";
export { ForwardRef as ReactComponent };